import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Tracking } from '@panamax/app-state';
import { OrderItem } from '@usf/ngrx-order';
import { Product } from 'src/app/shared/models/product.model';
import { SharedTrackingService } from 'src/app/shared/services/analytics/shared-tracking.service';
import { CONVERT_TO_WILL_CALL_ANALYTICS_ACTIONS } from './convert-to-will-call-analytics.actions';
import { ConvertToWillCallAnalyticsMessages } from './convert-to-will-call-analytics.constants';
import {
  willCallModalOpen,
  willCallModalClose,
  submitConvertToWillCallRequest,
} from './convert-to-will-call-analytics.transformers';

@Injectable({
  providedIn: 'root',
})
export class ConvertToWillCallAnalyticsService {
  constructor(private store: Store) {}
  trackWillCallModalOpen(
    orderId: string,
    divisionNumber: number,
    orderItems: OrderItem[],
    productMap: Map<number, Product>,
  ) {
    const products = SharedTrackingService.analyticsProductData(
      orderItems,
      productMap,
      divisionNumber,
    );
    const tracking: Tracking = {
      analytics: {
        data: {
          capability: ConvertToWillCallAnalyticsMessages.capability,
          event: ConvertToWillCallAnalyticsMessages.willCallModalOpenEvent,
          orderId: orderId,
          modalName: ConvertToWillCallAnalyticsMessages.modalName,
          products: products,
        },
        transformFunc: willCallModalOpen,
      },
    };
    this.store.dispatch(
      CONVERT_TO_WILL_CALL_ANALYTICS_ACTIONS.trackWillCallModalOpen({
        tracking,
      }),
    );
  }

  trackWillCallModalClose(
    orderId: string,
    divisionNumber: number,
    orderItems: OrderItem[],
    productMap: Map<number, Product>,
  ) {
    const products = SharedTrackingService.analyticsProductData(
      orderItems,
      productMap,
      divisionNumber,
    );
    const tracking: Tracking = {
      analytics: {
        data: {
          capability: ConvertToWillCallAnalyticsMessages.capability,
          event: ConvertToWillCallAnalyticsMessages.willCallModalCloseEvent,
          orderId: orderId,
          modalName: ConvertToWillCallAnalyticsMessages.modalName,
          products: products,
        },
        transformFunc: willCallModalClose,
      },
    };
    this.store.dispatch(
      CONVERT_TO_WILL_CALL_ANALYTICS_ACTIONS.trackWillCallModalClose({
        tracking,
      }),
    );
  }

  trackSubmitConvertToWillCallRequest(
    orderId: string,
    divisionNumber: number,
    orderItems: OrderItem[],
    productMap: Map<number, Product>,
  ) {
    const products = SharedTrackingService.analyticsProductData(
      orderItems,
      productMap,
      divisionNumber,
    );
    const tracking: Tracking = {
      analytics: {
        data: {
          capability: ConvertToWillCallAnalyticsMessages.capability,
          event: ConvertToWillCallAnalyticsMessages.submitWillCallRequestEvent,
          orderId: orderId,
          modalName: ConvertToWillCallAnalyticsMessages.modalName,
          products: products,
        },
        transformFunc: submitConvertToWillCallRequest,
      },
    };
    this.store.dispatch(
      CONVERT_TO_WILL_CALL_ANALYTICS_ACTIONS.trackSubmitConvertToWillCallRequest(
        {
          tracking,
        },
      ),
    );
  }
}
